import { render, staticRenderFns } from "./Followee.vue?vue&type=template&id=6b61d299&scoped=true&"
import script from "./Followee.vue?vue&type=script&lang=js&"
export * from "./Followee.vue?vue&type=script&lang=js&"
import style0 from "./Followee.vue?vue&type=style&index=0&id=6b61d299&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b61d299",
  null
  
)

export default component.exports